import { IMetricOptions, IMetricData } from "@curefit/metrics-common";
import { UserGoalView, UserTrackableSymptomUpsertRequest, BaseUserInfo } from "@curefit/gmf-common";
import { PatientPersonalProfile } from "@curefit/ups-common";
import * as RouteConfigs from "../routes";
import {
    IPatientAllergy,
    IPatientExamination,
    IPatientSystemiscExamination,
    IPatientSystemReview,
    IMentalStatusExamination
} from "@curefit/ehr-common";
import { IPrescription, IAppointmentScheduleResponse, ITwilioAccessToken, ISymptom, ILabtestPrescription, IDiagnosticLabTestItem } from "@curefit/care-common";
import { ApiManager } from "../api/ApiManager"
import {
    FETCH_CHAT_ACCESS_TOKEN_SUCCESS,
    FETCH_ONGOING_CONSULTATION_DETAILS_SUCCESS,
    FETCH_VIDEO_ACCESS_TOKEN_SUCCESS,
    UPDATE_CHIEF_COMPLAINTS,
    UPDATE_PATIENT_PERSONAL_INFO,
    UPDATE_CURRENT_ALLERGIES,
    UPDATE_CURRENT_PRESCRIPTION,
    UPDATE_EXAMINATIONS,
    UPDATE_ILLNESSES,
    UPDATE_PAST_CONDITIONS,
    UPDATE_SYSTEMIC_EXAMINATIONS,
    CLEAR_ONGOING_CONSULTATION_DETAILS,
    SAVE_REVIEW_OF_SYSTEMS_DATA, UPDATE_MENTAL_STATUS_EXAMINATIONS,
    UPDATE_PATIENT_PLAN, UPDATE_CURRENT_PATIENT_GOALS,
    UPDATE_CURRENT_PATIENT_SECONDARY_GOALS,
    UPDATE_CURRENT_PATIENT_TRACKABLE_SYMPTOMS,
    SAVE_FETCHED_USER_METRICS,
    FETCH_ALL_STATIC_DATA_SUCCESS,
    FETCH_ALL_STATIC_DATA_SUCCESS_NEW,
    FETCH_PATIENT_PLAN_ELIGIBILITY_INFO_SUCCESS,
    UPDATE_DIAGNOSTIC_LABTESTS_DETAILS,
    SAVE_EDITED_LAB_TESTS,
    UPDATE_MANUAL_LABTESTS_DETAILS,
    UPDATE_MEDICAL_PROFILE,
    UPDATE_CURRENT_CONFIG_MEDICAL_PROFILE,
    UPDATE_PATIENT_NUMBER_FOR_AUDIO_CALL,
    UPDATE_NO_PRESENTING_ILLNESS,
    SAVE_CONSULTATION_TEMPLATES_RESPONSE,
    SAVE_SUB_SECTIONS_RECOMMENDATIONS,
    UPDATE_NEW_CONFIG_DATA,
    UPDATE_SUGGESTIONS_CONSULTATION_DATA,
    UPDATE_CURRENT_CONSULTATION_DATA,
    GET_IS_ACTIVE_COVID_PACK,
    STORE_APPLIED_TEMPLATES, ADD_USED_SUGGESTION_FOR_EDITOR
} from "./ActionTypes"
import { IOngoingConsultation, IOngoingConsultationInvalid } from "../models/IOngoingConsultation"
import { IAppointmentScheduleWithOnlyId } from "../models/IAppointmentScheduleWithOnlyId"
import {
    AccessTokenRequestConstants,
    ConsultationStatusConstant,
    ForceCloseReason,
    RECOMMENDATIONS_SECTIONS,
    CONSULTATION_CHANNELS,
    toastNotificationAppearance,
    SEQUENTIAL_RECOMMENDATIONS_SECTIONS,
    MISSED_REASON_CODE
} from "../utils/AppConstants";
import AppointmentStatusRequestBuilder from "../builder/AppointmentStatusRequestBuilder";
import CommunicationAccessTokenRequestParamsBuilder from "../builder/CommunicationAccessTokenRequestParamsBuilder";
import { IEHRSavePatientMedicalProfile, INewConfigData } from "../models/patients/IEHRSavePatientMedicalProfile";
import IDifferentialDiagnosis from "../models/IDifferentialDiagnosis";
import IPatientLifestylePlanWrapper from "../models/patients/IPatientLifestylePlanWrapper";
import IGenericPlanPrescriptionDetailObject from "../models/gms/IGenericPrescriptionDetailObject";
import ModelFactory from "../models/ModelFactory";
import LocalStorageUtils from "../utils/LocalStorageUtils";
import { UIConfigurationActions } from "./UIConfigurationActions";

import { IStaticDataResponseNew } from "../models/staticData/IStaticDataResponseNew";
import { AppointmentsActions } from "./AppointmentsActions";
import { PatientCompleteInfoActions } from "./PatientCompleteInfoActions";
import IPrivateNotes from "../models/IPrivateNotes";
import AppUtils from "../utils/AppUtils";
import { isEmpty as _isEmpty, merge as _merge, get as _get } from "lodash";
import * as ActionTypes from "./ActionTypes";
import { IConstituentTemplate } from "../models/PdfTemplatesModels";
import IDoctorProfile from "../models/IDoctorProfile";
import { EHRRequestMapper } from "../api/EHRRequestMapper";
import { IFetchConfigResponse } from "../models/IFetchLoggingConfig";
import { OverrideActions } from "./OverrideActions";
import ITreatmentPlanTemplateResponseObj from "../models/ITreatmentPlanTemplateResponse";
import { EventNames } from "../utils/EventTrackerConstants";
import ConsultationUtils from "../utils/ConsultationUtils";
import { ConsentParam } from "../builder/ConsentParamBuilder";
import { IUserFitnessManagedPlanParams } from "../containers/Patient/Transform/interface";


export class OngoingConsultationActions {

    /* TODO: TEMP ACTION, to be changed */

    static updateConfigMedicalProfile = (medicalProfile: IEHRSavePatientMedicalProfile) => {
        return { type: UPDATE_CURRENT_CONFIG_MEDICAL_PROFILE, medicalProfile }
    }

    static fetchOngoingConsultationDetailsSuccess = (ongoingConsultation: IOngoingConsultation) => {
        // console.log(_merge({}, ongoingConsultation.medicalProfile.currentConsultationData, ongoingConsultation.medicalProfile.oldConsultationData), "======================");
        // ongoingConsultation.medicalProfile.currentConsultationData = _merge({}, ongoingConsultation.medicalProfile.currentConsultationData, ongoingConsultation.medicalProfile.oldConsultationData);
        if (AppUtils.isDoctorConsultation((ongoingConsultation || {}).appointmentSchedule) && ongoingConsultation.medicalProfile && ongoingConsultation.medicalProfile.currentConsultationData) {
            ongoingConsultation.medicalProfile.currentConsultationData = EHRRequestMapper.getConfigBasePrescriptionFromEHRGerPrescriptionResponse(ongoingConsultation.medicalProfile.currentConsultationData)
        }
        return { type: FETCH_ONGOING_CONSULTATION_DETAILS_SUCCESS, ongoingConsultation: ongoingConsultation };
    }

    static updateDiagnosticLabTests = (diagnosticLabTests: any) => {
        return { type: UPDATE_DIAGNOSTIC_LABTESTS_DETAILS, diagnosticLabTests }
    }

    static updateManualLabTests = (labTests: IDiagnosticLabTestItem[]) => {
        return { type: UPDATE_MANUAL_LABTESTS_DETAILS, labTests }
    }

    static fetchAllStaticDataSuccess = (staticData: IStaticDataResponseNew) => {
        return { type: FETCH_ALL_STATIC_DATA_SUCCESS_NEW, allStaticData: staticData }
    }

    static fetchChatAccessTokenSuccess = (chatAccessToken: ITwilioAccessToken[]) => {
        return { type: FETCH_CHAT_ACCESS_TOKEN_SUCCESS, chatAccessToken };
    }

    static fetchVideoAccessTokenSuccess = (videoAccessToken: ITwilioAccessToken[]) => {
        return { type: FETCH_VIDEO_ACCESS_TOKEN_SUCCESS, videoAccessToken };
    }

    static savePatientDiagnosticLabTests = (response: ILabtestPrescription[]) => {
        return { type: ActionTypes.SAVE_PATIENT_DIAGNOSTIC_LAB_TESTS, patientDiagnosticLabTests: response }
    }

    static saveManualLabTests = (dispatch: any, labTests: IDiagnosticLabTestItem[]) => {
        dispatch(OngoingConsultationActions.updateManualLabTests(labTests));
    };

    static storeAppliedTemplatesForCurrentConsultation = (templateId: string, flowContext: string) => {
        return {
            type: flowContext === EventNames.Edit_Prescription ? ActionTypes.STORE_APPLIED_TEMPLATES_EDIT : ActionTypes.STORE_APPLIED_TEMPLATES_ONGOING,
            templateId
        }
    }

    static removeAppliedTemplate = (templateId: string, flowContext: string) => {
        return {
            type: flowContext === EventNames.Edit_Prescription ? ActionTypes.REMOVE_APPLIED_TEMPLATES_EDIT : ActionTypes.REMOVE_APPLIED_TEMPLATES_ONGOING,
            templateId
        }
    }

    static fetchChatContext = (dispatch: any, appointmentId: number, commUserId: number) => {
        let reqBuilder: CommunicationAccessTokenRequestParamsBuilder = new CommunicationAccessTokenRequestParamsBuilder();
        reqBuilder.setAppointmentId(appointmentId).setCommUserId(commUserId);
        reqBuilder.setCommMode(AccessTokenRequestConstants.commMode.CHAT).setEndPointId(AccessTokenRequestConstants.endPointId.WEB).setCommUserType(AccessTokenRequestConstants.commUserType.DOCTOR);
        ApiManager.getAlbusApis().getTwilioContext(reqBuilder.build()).then(accessToken => {
            dispatch(OngoingConsultationActions.fetchChatAccessTokenSuccess(accessToken));
        }).catch(error => {
            throw error;
        });
    }

    static fetchVideoContext = (dispatch: any, appointmentId: number, commUserId: number) => {
        let reqBuilder: CommunicationAccessTokenRequestParamsBuilder = new CommunicationAccessTokenRequestParamsBuilder();
        reqBuilder.setAppointmentId(appointmentId).setCommUserId(commUserId);
        reqBuilder.setCommMode(AccessTokenRequestConstants.commMode.VIDEO).setEndPointId(AccessTokenRequestConstants.endPointId.WEB).setCommUserType(AccessTokenRequestConstants.commUserType.DOCTOR);
        ApiManager.getAlbusApis().getTwilioContext(reqBuilder.build()).then(accessToken => {
            dispatch(OngoingConsultationActions.fetchVideoAccessTokenSuccess(accessToken));
        }).catch(error => {
            throw error;
        });
    }

    static fetchWrapperOngoingConsultationDetailsSuccess = (ongoingConsultation: IOngoingConsultation) => {
        return (dispatch: any) => {
            dispatch(OngoingConsultationActions.fetchOngoingConsultationDetailsSuccess(ongoingConsultation));
            dispatch(OngoingConsultationActions.fetchAllStaticDataSuccess(ongoingConsultation.staticData));
            dispatch(OngoingConsultationActions.fetchChatAccessTokenSuccess(ongoingConsultation.chatAccessToken));
            dispatch(AppointmentsActions.fetchAppointmentsForPatientSuccess(ongoingConsultation.patientConsultations))
            // dispatch(PatientCompleteInfoActions.fetchPatientCompleteDetailsSuccess(ongoingConsultation.patientCompleteDetails as any));
            dispatch(PatientCompleteInfoActions.fetchPatientTypeFormDataSuccess(ongoingConsultation.typeFormData));
        }
    }

    static handleInvalidOngoingConsultation = () => {
        AppUtils.triggerToastNotification("This consultation status is invalid. It might have been cancelled or rescheduled.", toastNotificationAppearance.error);
        setTimeout(() => {
            RouteConfigs.RouteUtils.navigateToDashboard();
        }, 3000);
    }

    static fetchOngoingConsultationDetails = async (dispatch: any, patientId: number, appointmentId: number, curefitId: number, isSelf: boolean, doctorProfile: IDoctorProfile, shouldFetchPrescriptions?: boolean, shouldFetchPrescription?: boolean, appointmentDoctorType?: string): Promise<any> => {
        ApiManager.getOrionApis().getOngoingConsultationDetails(patientId, curefitId, appointmentId, isSelf, shouldFetchPrescription, ConsultationUtils.isPackInfoRequired(doctorProfile.type)).then((ongoingConsultation: IOngoingConsultation | IOngoingConsultationInvalid) => {
            if ((ongoingConsultation as IOngoingConsultationInvalid).status === "invalid") {
                OngoingConsultationActions.handleInvalidOngoingConsultation();
                return;
            }
            let currentPrescription: any = (ongoingConsultation as IOngoingConsultation).currentPrescription;
            if (currentPrescription && currentPrescription.prescriptionTemplateMapping && currentPrescription.prescriptionTemplateMapping.referenceIds) {
                if (currentPrescription.prescriptionTemplateMapping.templateIds) {
                    currentPrescription.prescriptionTemplateMapping.templateIds = [...currentPrescription.prescriptionTemplateMapping.referenceIds,
                    ...currentPrescription.prescriptionTemplateMapping.templateIds];
                } else {
                    currentPrescription.prescriptionTemplateMapping.templateIds = [...currentPrescription.prescriptionTemplateMapping.referenceIds]
                }
            }
            ongoingConsultation = ongoingConsultation as IOngoingConsultation;
            if (ongoingConsultation) {
                ongoingConsultation.patientPersonalProfile && ongoingConsultation.patientPersonalProfile.personalInformation && ongoingConsultation.patientPersonalProfile.personalInformation.commute ? ongoingConsultation.patientPersonalProfile.personalInformation.commute.value = AppUtils.getTimeInDecimalMinutesFromSeconds(ongoingConsultation.patientPersonalProfile.personalInformation.commute.value) : undefined;
                ongoingConsultation.patientPersonalProfile && ongoingConsultation.patientPersonalProfile.personalInformation && ongoingConsultation.patientPersonalProfile.personalInformation.sittingTime ? ongoingConsultation.patientPersonalProfile.personalInformation.sittingTime.value = AppUtils.getTimeInDecimalHoursFromSeconds(ongoingConsultation.patientPersonalProfile.personalInformation.sittingTime.value) : undefined;
            }
            dispatch(OngoingConsultationActions.fetchWrapperOngoingConsultationDetailsSuccess(ongoingConsultation));
            dispatch(UIConfigurationActions.setUIconfiguration(ongoingConsultation.uiConfiguration));
            LocalStorageUtils.createMealsMap(_get(ongoingConsultation, "medicalProfile.patientData.newConfigData.dietPlan", {}));
            // Fetch patient metrics data (if any exist)
            // Not fetching these details on server to save time on opening consultation, so that doctor doesn't wait and details can be loaded
            // in background
            if (!_isEmpty(ongoingConsultation) && !_isEmpty(ongoingConsultation.patientGoals)) {
                const patientMetricIds = AppUtils.getNonActiveMetricIdsForGoals(AppUtils.getPatientPrimaryGoals(ongoingConsultation.patientGoals), null);
                if (!_isEmpty(patientMetricIds)) {
                    patientMetricIds.map(metricId => {
                        let userMetricReq = ModelFactory.createUserMetricReqObject(curefitId.toString(), patientId.toString(), Number(metricId), isSelf);
                        userMetricReq.sortDesc = true;
                        OngoingConsultationActions.getUserMetrics(dispatch, userMetricReq);
                    })
                }
            }

            // fetch suggestions list for sub sections
            if (doctorProfile) {
                const { subServiceType } = ongoingConsultation.appointmentSchedule.consultationProduct;
                OngoingConsultationActions.fetchSuggestionsForSubSections(dispatch, doctorProfile.id, subServiceType);
            }

            if (ongoingConsultation.appointmentSchedule.channel && ongoingConsultation.appointmentSchedule.channel === CONSULTATION_CHANNELS.AUDIO && ongoingConsultation.appointmentSchedule && ongoingConsultation.appointmentSchedule.appointmentActionsWithContext
                && ongoingConsultation.appointmentSchedule.appointmentActionsWithContext
                && ongoingConsultation.appointmentSchedule.appointmentActionsWithContext.audioActionWithContext
                && ongoingConsultation.appointmentSchedule.appointmentActionsWithContext.audioActionWithContext.context
                && ongoingConsultation.appointmentSchedule.appointmentActionsWithContext.audioActionWithContext.context.twilioCommunicationMode
                && ongoingConsultation.appointmentSchedule.appointmentActionsWithContext.audioActionWithContext.context.twilioCommunicationMode.modeName) {
                const phoneNumber = parseInt(ongoingConsultation.appointmentSchedule.appointmentActionsWithContext.audioActionWithContext.context.twilioCommunicationMode.modeName);
                dispatch(OverrideActions.overridePatientNumberForAudioCall(phoneNumber));

            }
        });
    }

    static fetchSuggestionsForSubSections = (dispatch: any, doctorId: number, doctorType: string, patientId?: number) => {
        //fetch Chief Complaints, advices recommendations
        ApiManager.getEHRApis().getSubSectionsRecommendations(doctorId, "doctor", doctorType, RECOMMENDATIONS_SECTIONS[doctorType] || []).then((response: any) => {
            dispatch({
                type: SAVE_SUB_SECTIONS_RECOMMENDATIONS,
                payload: response.data || {}
            })
        });
    }

    static getDoctorWiseSubSectionRecommendations(recommendation: any, doctorId: number, prescriptionDetails?: INewConfigData) {
        return ApiManager.getCareRecommendationServiceApis().getDoctorWiseSubSectionRecommendations(doctorId, recommendation.url, prescriptionDetails)
    }

    static storeDoctorRecommendations(recommendations: any, key: string) {
        return {
            type: SAVE_SUB_SECTIONS_RECOMMENDATIONS,
            payload: { [key]: recommendations }
        }
    }

    static getMedicalProfile = (dispatch: any, patientId: number, appointmentId: number, doctorType: string) => {
        ApiManager.getEHRApis().getMedicalProfile(patientId, appointmentId, doctorType).then((response: any) => {
            dispatch({
                type: UPDATE_PAST_CONDITIONS,
                payload: response || {}
            })
        })
    }

    static getPrescriptionByReferenceId = (patientId: number, appointmentId: number, doctorType: string) => {
        return ApiManager.getEHRApis().getMedicalProfile(patientId, appointmentId, doctorType)
    }

    static fetchConsultationPdfTemplates = (dispatch: any, appointmentSchedule: IAppointmentScheduleResponse) => {
        /* Fetch prescription templates */
        // if (AppUtils.isDefined(appointmentSchedule.doctor) && AppUtils.isDefined(appointmentSchedule.doctor.id)) {
        /* make API call to fetch templates */
        // }
        return ApiManager.getOllivanderServiceApis().fetchTemplates(
            appointmentSchedule.doctor.id,
            // 20053,
            appointmentSchedule.center.id,
            appointmentSchedule.consultationProduct.subServiceType
            // 5
        ).then((response: IConstituentTemplate) => {
            const templateIdToNameMap = AppUtils.setPdfTemplatesIdToNameMap(response.constituentTemplates || []);
            const templateNameToDataMap = AppUtils.setPdfTemplateNameToDataMap(response.constituentTemplates || []);
            const responseToSave = { ...response, templateIdToNameMap, templateNameToDataMap };
            dispatch(OngoingConsultationActions.saveTemplatesResponse(responseToSave));
        });
    };

    static saveTemplatesResponse = (data: any) => {
        return { type: SAVE_CONSULTATION_TEMPLATES_RESPONSE, payload: data }
    }

    static clearOngoingConsultationDetails = () => {
        return { type: CLEAR_ONGOING_CONSULTATION_DETAILS };
    }

    static updateCurrentPrescription = (prescription: IPrescription) => {
        let newPrescription: IPrescription = {
            ...prescription
        }
        if (prescription.noPresentingIllness) {
            newPrescription.patientSymptomSet = []
        }
        return { type: UPDATE_CURRENT_PRESCRIPTION, prescription: newPrescription };
    }

    static updateCurrentPatientSecondaryGoals = (patientGoals: UserGoalView[]) => {
        return { type: UPDATE_CURRENT_PATIENT_SECONDARY_GOALS, patientGoals };
    }

    static updateCurrentPatientInterventions = (patient_interventions: UserGoalView[]) => {
        return { type: ActionTypes.UPDATE_CURRENT_PATIENT_INTERVENTIONS, patient_interventions: patient_interventions };
    }

    static updateCurrentAllergies = (allergies: IPatientAllergy[]) => {
        return { type: UPDATE_CURRENT_ALLERGIES, allergies };
    }

    static updateCurrentChiefComplaints = (chiefComplaints: ISymptom[]) => {
        return { type: UPDATE_CHIEF_COMPLAINTS, chiefComplaints }
    }

    static updateCurrentIllnesses = (illnesses: string) => {
        return { type: UPDATE_ILLNESSES, illnesses }
    }

    static updatePatientMedicalProfile = (medicalProfile: IEHRSavePatientMedicalProfile, subSectionKey: string) => {
        return { type: UPDATE_PAST_CONDITIONS, medicalProfile }
    }

    static updateExaminations = (exams: IPatientExamination[]) => {
        return { type: UPDATE_EXAMINATIONS, exams }
    }

    static updateCurrentPersonalInfo = (patientPersonalProfile: PatientPersonalProfile) => {
        return { type: UPDATE_PATIENT_PERSONAL_INFO, patientPersonalProfile }
    }

    static updateEditedPatientPlan = (patientPlan: IPatientLifestylePlanWrapper, dispatch: any) => {
        const newConfigData = _get(patientPlan, ["newConfigData"]);
        let newPatientPlan: IPatientLifestylePlanWrapper = _get(patientPlan, ["updatedPersonalInfo"]);
        if (patientPlan.noPresentingIllnessByTherapist) {
            newPatientPlan.chiefComplaintsByTherapist = []
        }
        if (patientPlan.noPresentingIllness) {
            newPatientPlan.chiefComplaints = []
        }
        dispatch({ type: UPDATE_NEW_CONFIG_DATA, newConfigData })
        dispatch({ type: UPDATE_PATIENT_PLAN, patientPlan: newPatientPlan })
    }

    static updateSystemicExaminations = (exams: IPatientSystemiscExamination[]) => {
        return { type: UPDATE_SYSTEMIC_EXAMINATIONS, exams }
    }

    static updateMentalStatusExaminations = (exams: IMentalStatusExamination[]) => {
        return { type: UPDATE_MENTAL_STATUS_EXAMINATIONS, exams }
    };

    static savePatientPrescription = (dispatch: any, appointmentId: number, prescription: IPrescription) => {
        let appointmentScheduleOnlyId: IAppointmentScheduleWithOnlyId = { id: appointmentId };
        let updatedPrescription = { ...prescription, appointmentSchedule: appointmentScheduleOnlyId }
        return ApiManager.getAlbusApis().savePatientPrescription(appointmentId, updatedPrescription);
    }

    static savePatientPrescriptionPDF = (dispatch: any, appointmentId: number, prescription: File, type: string) => {
        return ApiManager.getAlbusApis().uploadPrescription(appointmentId, prescription, type);
    }

    static savePatientPlanPDF = (dispatch: any, appointmentId: number, plan: File, type: string) => {
        return ApiManager.getAlbusApis().uploadPlan(appointmentId, plan, type);
    }

    static saveDifferentialDiagnosis = (dispatch: any, appointmentId: number, differentialDiagnosis: IDifferentialDiagnosis) => {
        let appointmentScheduleOnlyId: IAppointmentScheduleWithOnlyId = { id: appointmentId };
        return ApiManager.getAlbusApis().saveDifferentialDiagnosis(appointmentId, differentialDiagnosis);
    }

    static savePrivateNotes = (dispatch: any, appointmentId: number, privateNotes: IPrivateNotes) => {
        return ApiManager.getAlbusApis().savePrivateNotes(appointmentId, privateNotes);
    }

    static fetchCaseSummary = (dispatch: any, appointmentId: number) => {
        return ApiManager.getAlbusApis().fetchCaseSummary(appointmentId);
    };

    static submitConsultationFeedbackForm = (dispatch: any, consultationId: number) => {
        return dispatch({
            type: ActionTypes.SUBMIT_CONSULTATION_FEEDBACK_FORM,
            consultationId
        })
    }

    static getIsActiveCovidPack = (dispatch: any, userId: number) => {
        return ApiManager.getAlbusApis().getIsActiveCovidPack(userId).then((response) => {
            dispatch(OngoingConsultationActions.saveActiveCovidPackAction(response));
        }).catch(console.log)
    }

    static saveActiveCovidPackAction = (response: any) => {
        return {
            type: GET_IS_ACTIVE_COVID_PACK,
            payload: response
        }
    }

    static updateAppointmentStatus = (dispatch: any, bookingId: number, appointmentId: number, status: ConsultationStatusConstant) => {
        return ApiManager.getOrionApis().updateAppointmentStatus(bookingId, appointmentId, status);
    }

    static updatePatientPlanEligibilityMasks = (dispatch: any, userId: String, secondaryUserId: String, isSelf: Boolean, eligibilityMasks: String[]) => {
        return ApiManager.getOrionApis().updatePatientPlanEligibilityMasks(userId, secondaryUserId, isSelf, eligibilityMasks);
    }
    static forceCompleteAppointment = (dispatch: any, status: string, bookingId: number, appointmentId: number, reasonCode: ForceCloseReason, reasonText: string, missedReasonCode: MISSED_REASON_CODE) => {
        let reqBuilder: AppointmentStatusRequestBuilder = new AppointmentStatusRequestBuilder();
        reqBuilder.setStatus(status).setForcedUpdate();
        reqBuilder.setReasonCode(reasonCode).setReasonText(reasonText);
        if (missedReasonCode) reqBuilder.setMissedReasonCode(missedReasonCode);
        return ApiManager.getAlbusApis().updateAppointmentStatus(bookingId, appointmentId, reqBuilder.build());
    }

    static updatePatientProfileData = (dispatch: any, curefitId: string, profile: PatientPersonalProfile) => {
        return ApiManager.getAlbusApis().updatePatientPersonalInfo(curefitId, profile);
    }

    static saveReviewOfSystemsData = (data: IPatientSystemReview[]) => {
        return {
            type: SAVE_REVIEW_OF_SYSTEMS_DATA,
            payload: data
        }
    }

    /* SAVE ALL PROFILES FOR PATIENT */
    static saveAllProfilesForPatient = (dispatch: any, curefitId: number, patientId: number, isSelf: boolean, profile: PatientPersonalProfile) => {
        return ApiManager.getPolarisApis().saveAllProfilesForPatient(curefitId, patientId, isSelf, profile);
    }

    static savePatientPlanInDraft = (dispatch: any, consultationId: number, patientPlan: IGenericPlanPrescriptionDetailObject[]) => {
        return ApiManager.getOrionApis().savePatientPlanInDraft(consultationId, patientPlan);
    }

    static launchPatientPlan = (dispatch: any, patientId: number, req: any) => {
        return ApiManager.getGMFApis().launchPatientPlan(patientId.toString(), req);
    }

    static launchPatientGoals = (dispatch: any, patientId: number, req: any) => {
        return ApiManager.getGMFApis().launchPatientGoals(patientId.toString(), req);
    }

    static savePatientGoals = (dispatch: any, patientId: number, patientGoals: UserGoalView[]) => {
        return ApiManager.getGMFApis().savePatientGoals(patientId, patientGoals);
    }

    static savePatientGoalsEdit = (dispatch: any, patientId: number, req: any) => {
        return ApiManager.getGMFApis().savePatientGoalsEdit(patientId, req);
    }

    static saveEditedPatientGoals = (patientGoals: UserGoalView[]) => {
        return { type: UPDATE_CURRENT_PATIENT_GOALS, patientGoals }
    }

    static saveEditedPatientTrackableSymptoms = (trackableSymptoms: UserTrackableSymptomUpsertRequest[]) => {
        return { type: UPDATE_CURRENT_PATIENT_TRACKABLE_SYMPTOMS, trackableSymptoms }
    }

    static savePatientTrackableSymptoms = (dispatch: any, userId: number, reqData: any) => {
        let updatedReq = { userTrackableSymptoms: reqData };
        return ApiManager.getGMFApis().savePatientTrackableSymptoms(userId, updatedReq)
    }

    static deletePatientTrackableSymptoms = (dispatch: any, userId: number, reqData: any) => {
        let updatedReq = { userTrackableSymptoms: reqData };
        return ApiManager.getGMFApis().deletePatientTrackableSymptoms(userId, updatedReq)
    }

    static addUserMetric = (dispatch: any, userId: string, patientId: number, isSelf: boolean, metricId: string, metricValue: number) => {
        let addUserMetric = ModelFactory.createNewAddUserMetricObj(userId, patientId, isSelf, metricId, metricValue);
        return ApiManager.getMetricServiceApis().saveUserMetric(addUserMetric);
    }

    static saveFetchedUserMetrics = (data: IMetricData[], metricId: number) => {
        return {
            type: SAVE_FETCHED_USER_METRICS,
            payload: { data, metricId }
        }
    };


    static getUserMetrics = (dispatch: any, req: IMetricOptions) => {
        ApiManager.getMetricServiceApis().fetchUserMetric(req).then(response => {
            dispatch(OngoingConsultationActions.saveFetchedUserMetrics(response, req.metricId));
        });
    }

    static clientLogger = (err: any) => {
        ApiManager.getOrionApis().orionClientLogger(err);
    }

    static savePatientPlanNew = (consultation: IAppointmentScheduleResponse, prescription: IPrescription, patientPlan: IPatientLifestylePlanWrapper, planId: string, status: ConsultationStatusConstant, isSelf: boolean, medicalProfile?: any) => {
        return ApiManager.getOrionApis().savePatientPlanNew(consultation, prescription, patientPlan, planId, status, isSelf, medicalProfile);
    }

    static removeWorkflowObject = (consultation: IAppointmentScheduleResponse, isPrescriptionObject: boolean) => {
        return ApiManager.getOrionApis().removePlanWorkflowObject(consultation, isPrescriptionObject);
    }

    // static getPatientPlanEligibilityStatus = (dispatch: any, userInfo: BaseUserInfo) => {
    //     ApiManager.getGMFApis().getPatientPlanEligibilityStatus(userInfo).then((patientPlanEligibilityInfo: IPatientPlanEligibilityInfoResponse) => {
    //         dispatch({ type: FETCH_PATIENT_PLAN_ELIGIBILITY_INFO_SUCCESS, patientPlanEligibilityInfo: patientPlanEligibilityInfo });
    //     }).catch((err) => {
    //         console.error(`Error while fetching patient plan eligibility info`, err);
    //     });
    // }
    static updateEditedPatientLabTests = (diagnosticLabTests: any) => {
        return { type: SAVE_EDITED_LAB_TESTS, diagnosticLabTests }
    }
    // static addSymptomForReview = (name: string): Promise<any> => {
    //     return ApiManager.getAlbusApis().addSymptomForReview(name);
    // }

    // static addSymptomForReview = function(dispatch: any, name: string) {
    //     return ApiManager.getAlbusApis().addSymptomForReview(name).then((response: any)=> {
    //         dispatch(OngoingConsultationActions.addSymptomForReviewSuccess(response));
    //     });
    // }

    static addSymptomForReviewSuccess = function (name: any) {
        return { type: ActionTypes.ADD_NEW_SYMPTOM, name };
    }


    static addSymptomForReview = (name: string): Promise<any> => {
        return ApiManager.getAlbusApis().addSymptomForReview(name);
    }

    static fetchLogLevelForAgent(resourceId: number): Promise<IFetchConfigResponse> {
        return ApiManager.getOllivanderServiceApis().fetchLogConfig(resourceId);
    }

    static fetchTreatmentPlanSuggestions = (dispatch: any, doctorId: number, diagnosis?: Array<string>) => {
        if (diagnosis && diagnosis.length > 0) {
            ApiManager.getEHRApis().getTreatmentPlanTemplates(doctorId, diagnosis)
                .then((response: Array<ITreatmentPlanTemplateResponseObj>) => {
                    dispatch({
                        type: UPDATE_SUGGESTIONS_CONSULTATION_DATA,
                        payload: response || []
                    })
                });
        }
        else {
            dispatch({
                type: UPDATE_SUGGESTIONS_CONSULTATION_DATA,
                payload: []
            })
        }
    }

    static updateCurrentConsultationData = (medicalProfile: IEHRSavePatientMedicalProfile) => {
        return { type: UPDATE_CURRENT_CONSULTATION_DATA, medicalProfile }
    }


    static fetchAccessPolicyForCurrentUser(principleReferenceEntity: string, ownerReferenceEntity: string, ownerReferenceEntityId: string, resourceType: string, principleReferenceEntityId: string): Promise<any> {
        return ApiManager.getAlbusApis().fetchAccessPolicyForCurrentUser(principleReferenceEntity, ownerReferenceEntity, ownerReferenceEntityId, resourceType, principleReferenceEntityId);

    }

    static setAccessPolicyForCurrentUser(params: ConsentParam): Promise<any> {
        return ApiManager.getAlbusApis().setAccessPolicyForCurrentUser(params);

    }
    static addUsedSuggestionForEditor = (dispatch: any, subSectionKey: string, questionKey: string, val: string) => {
        dispatch({
            type: ADD_USED_SUGGESTION_FOR_EDITOR,
            payload: { subSectionKey, questionKey, val }
        })
    }

    static fetchUserFitnessManagedPlan = (requestParams: IUserFitnessManagedPlanParams) => {
        return ApiManager.getUserFitnessApis().fetchUserFitnessManagedPlan(requestParams);
    }

    static setFitnessPlan(userFitnessPlan: any, userFitnessPlanStartDate: any, isPublishedPlan: boolean, dispatch: any) {
        dispatch({
            type: ActionTypes.SET_ONGOING_CONSULTATION_FITNESS_PLAN,
            userFitnessPlan,
            userFitnessPlanStartDate,
            isPublishedPlan
        })
    }

    static saveUserFitnessPlan(userFitnessPlan: any, dispatch: any) {
        dispatch({
            type: ActionTypes.SET_ONGOING_CONSULTATION_USER_FITNESS_PLAN,
            userFitnessPlan,
        })
    }

    static fetchAllExercises(dispatch?: any) {
        ApiManager.getOrionApis().fetchAllExercises().then(exercises => {
            dispatch({
                type: ActionTypes.SAVE_EXERCISES_FOR_ONGOING_FITNESS_PLAN, exercises
            })
        })
    }



}


